// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3TpwB","ScrollX":"Scroll_ScrollX__n8WG2","ScrollY":"Scroll_ScrollY__2-kuJ"};